import _d from '@repperjs/debug';

/* eslint-disable no-unused-vars */
const log = _d('repper:services:paddle:index'),
    error = _d('repper:error'),
    warn = _d('repper:warning');
/* eslint-enable no-unused-vars */

let paddleInitialized = false;

const paddleScriptInitialized = new Promise((resolve, reject) => {
    // don't render on server
    if (typeof document === 'undefined' || typeof window === 'undefined') {
        resolve();
    }

    // already loaded!
    if (window.Paddle) resolve();

    const script = document.querySelector('#paddle-script');
    if (!script) {
        log('Paddle script not found in page.');
        reject(new Error('Paddle script not found'));
        return;
    }
    script.addEventListener('load', function () {
        log('Paddle script loaded');
        resolve();
    });
});

export const setupPaddle = async () => {
    if (paddleInitialized) {
        return window.Paddle;
    }

    await paddleScriptInitialized;

    log('setting up paddle');
    if (typeof window === 'undefined') {
        // we are rendering on the server
        warn('Server rendering');
        return;
    }

    if (!window.Paddle) {
        error('Paddle is not available on the window');
        return;
    }

    window.Paddle.Setup({ vendor: Number(process.env.PUBLIC_PADDLE_VENDOR) });
    paddleInitialized = true;
    log('Initialized paddle');
    return window.Paddle;
};

export const getPaddle = async () => {
    // initialize paddle the first time we need it
    if (!paddleInitialized) {
        await setupPaddle();
        paddleInitialized = true;
    }
    return window.Paddle;
};
